function PublicPage() {
  const path = window.location.pathname.replace('/public', '').replace(/^\//, '');

  return (
    <div className="public-page">
      <header className="public-header">
        <h1>Tim Hanson</h1>
      </header>
      <main className="public-content">
        {(!path || path === '/') ? <PublicHome /> : <PublicNotFound />}
      </main>
    </div>
  );
}

function PublicHome() {
  return (
    <div className="public-home">
      <section className="card" style={{ padding: 24 }}>
        <h2>Welcome</h2>
        <p>This is a public page. Content coming soon.</p>
      </section>
    </div>
  );
}

function PublicNotFound() {
  return (
    <div className="public-home">
      <section className="card" style={{ padding: 24 }}>
        <h2>Page Not Found</h2>
        <p>The page you're looking for doesn't exist.</p>
      </section>
    </div>
  );
}

export default PublicPage;
